import { z } from "zod";
export const BOOKING_STATUSES = [
    "draft",
    "requested",
    "refused",
    "pending_contract",
    "pending_deposit",
    "pending_caution",
    "confirmed",
    "completed",
    "deposit_pending",
    "deposit_released",
    "refund_requested",
    "cancelled",
];
export const bookingStatusSchema = z.enum(BOOKING_STATUSES);
export const BookingStatusEnum = {
    DRAFT: "draft",
    REQUESTED: "requested",
    REFUSED: "refused",
    PENDING_CONTRACT: "pending_contract",
    PENDING_DEPOSIT: "pending_deposit",
    PENDING_CAUTION: "pending_caution",
    CONFIRMED: "confirmed",
    COMPLETED: "completed",
    DEPOSIT_PENDING: "deposit_pending",
    DEPOSIT_RELEASED: "deposit_released",
    REFUND_REQUESTED: "refund_requested",
    CANCELLED: "cancelled",
};
